import { render, staticRenderFns } from "./EditAttribute.vue?vue&type=template&id=1b0ad373&scoped=true&"
import script from "./EditAttribute.vue?vue&type=script&lang=js&"
export * from "./EditAttribute.vue?vue&type=script&lang=js&"
import style0 from "./EditAttribute.vue?vue&type=style&index=0&id=1b0ad373&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ad373",
  null
  
)

export default component.exports